export default __webpack_public_path__ + "static/media/application_active.90a2ad28.svg";